<template>
  <div class="p-topEn__memberList">
    <template v-for="(m, i) in params">
      <en-member-slide :member="m"></en-member-slide>
    </template>
  </div>
</template>

<script>
  import { assets_path, breakpoint } from '@/_modules/utils/variables'
  import store from '@/_modules/stores';
  import {gsap, TweenMax, Cubic} from 'gsap/all';
  import EnMemberSlide from '@/_components/en-member-slide.vue';

  export default {
    components: {
      EnMemberSlide
    },
    data() {
      return {
        assets_path: assets_path,
        params: []
      }
    },
    store,
    computed: {
    },
    created() {
    },
    mounted() {
      this.params = JSON.parse(document.getElementById('js-param-en-member').textContent);
      this.$nextTick(this.start);
    },
    methods: {
      start() {

      }
    }
  }
</script>
